// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".archiv-detail{margin-top:100px}@media screen and (min-width:48em){.archiv-detail{margin-top:140px}}.archiv-detail time{display:block;margin-bottom:20px}@media screen and (min-width:48em){.archiv-info{margin:0 50px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
